import React, { useState } from 'react';
import { useHawkSearch } from 'shared/components/hawksearch/components/StoreProvider';
import CompareItemsModal from './CompareItemsModal';
import RocHawkConfig from 'features/search/RocHawkConfig';
import CompareItems from '../ui/Compare/CompareItems';
import ErrorBoundary from 'shared/util/ErrorBoundary';

/**
 * Component that renders the bar below the listing controls that houses the selected products for compare.
 *
 * @returns
 */
function CompareItemsBar() {
	const {
		actor,
		store: { itemsToCompare, itemsToCompareIds, comparedResults },
	} = useHawkSearch();

	const [popup, setPopup] = useState(false);

	const [error, setError] = useState(false);

	/**
	 * Grab the compared results from Hawk.
	 *
	 */
	async function getCompareItems() {
		try {
			const resp = await actor.getComparedItems({
				ClientGuid: RocHawkConfig.clientGuid || '',
				Ids: itemsToCompareIds,
			});
			actor.setComparedResults(resp.Results);
			setPopup(true);
		} catch (e) {
			setError(true);
			console.log(e);
		}
	}

	return (
		<ErrorBoundary>
			<div className="hawk-compare-bar">
				<CompareItems
					itemsList={itemsToCompare}
					onSelectCompareItems={getCompareItems}
					clearItems={() => actor.clearItemsToCompare()}
					onSelectTiles={(item) => actor.setItemsToCompare(item, false)}
					error={error}
				/>

				<CompareItemsModal resultItems={comparedResults} onModalToggle={setPopup} popup={popup} />
			</div>
		</ErrorBoundary>
	);
}

export default CompareItemsBar;
